<template>
  <el-card bg="white" style="padding-right: 10%">
    <el-form
      ref="form"
      :model="formData"
      :class="$i18n.locale === 'ja-ja' ? 'form_' : ''"
      input-height="36px"
      justify="end"
      space="10px 10px"
      :rules="rules"
    >
      <div class="flex-row">
        <!-- 姓名 -->
        <el-form-item
          :label="$t('subAddress.subAddress4' || '姓名')"
          class="formitem"
          style="margin-bottom: 0 !important"
          prop="receiverName"
        >
          <el-input v-model="formData.receiverName" :placeholder="$t('subAddress.subAddress20')"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item
          :label="$t('subAddress.subAddress9' || '电话')"
          label-width="200"
          class="formitem"
          style="margin-bottom: 0 !important"
          prop="receiverPhone"
        >
          <el-input v-model="formData.receiverPhone" :placeholder="$t('subAddress.subAddress21')"></el-input>
        </el-form-item>
      </div>

      <div class="flex-row">
        <!-- 地址 -->
        <el-form-item :label="$t('subAddress.subAddress5' || '地址')"  class="formitem" style="margin-bottom: 0 !important" prop="address">
          <el-cascader
            style="width: 100%"
            size="large"
            :placeholder="$t('subAddress.subAddress22')"
            v-model="formData.address"
            :options="options"
            :props="defaultParams"
            @change="addressChange"
          >
          </el-cascader>
        </el-form-item>
        <!-- 邮政编码 -->
        <el-form-item
          :label="$t('subAddress.subAddress6' || '邮政编码')"
          class="formitem"
          style="margin-bottom: 0 !important"
          prop="postcode"
        >
          <el-input v-model="formData.postcode" :placeholder="$t('subAddress.subAddress24')"></el-input>
        </el-form-item>
      </div>

      <div class="flex-row">
        <!-- 详细地址 -->
        <el-form-item
          :label="$t('subAddress.subAddress16' || '详细地址')"
          class="formitem"
          style="margin-bottom: 0 !important"
          prop="addressInfo"
        >
          <el-input v-model="formData.addressInfo" :placeholder="$t('subAddress.subAddress23')"></el-input>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('subAddress.subAddress8' || '备注')" class="formitem" style="margin-bottom: 0 !important" prop="notes">
          <el-input v-model="formData.notes" :placeholder="$t('subAddress.subAddress25')"></el-input>
        </el-form-item>
      </div>

      <div class="flex-center" style="margin-top: 10px;">
        <el-button type="info" plain @click="onCancel">{{ $t("subAddress.subAddress17" || "取消") }}</el-button>
        <el-button type="primary" @click="onSave()">
          <span v-if="isEdit">{{ $t("subAddress.subAddress19" || "保存修改") }}</span>
          <span v-else>{{ $t("subAddress.subAddress18" || "添加并使用") }}</span>
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
// import { getAreaJp } from "@/api/apiPubilc";
// import {
//   getAddressOptions,
//   postAddressEdit,
//   getAddresslist,
// } from "@/api/apiCustomer";
import { valKeys, clonKeys, clearKeys } from "@/utils/utils";
import { FormVerify } from "@/class";

export default {
  name: "SubAddressAdd",
  props: {
    props: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    addressValue: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      addressStr: this.$t("shouxufei41"),
      sub: {
        options: [],
        props: {
          label: "label",
          value: "id",
          expandTrigger: "hover",
        },
        addressValue: [],
      },
      options: [],
      formData: {
        receiverName: undefined,
        receiverPhone: undefined,
        provinceName: undefined,
        provence: undefined,
        cityName: undefined,
        city: undefined,
        areaName: undefined,
        area: undefined,
        addressInfo: undefined,
        postcode: undefined,
        notes: undefined,
        // 删除以下未使用的字段：
        // email: undefined,
        // companyName: undefined,
        // legalNo: undefined,
        // defaultAddress: 1,
        addressNo: undefined, // 保留，因为有校验规则
        address: [],
      },
      rules: {
        receiverName: [{ required: true, message: this.$t("addr.addr32"), trigger: "blur" }],
        receiverPhone: [{ required: true, message: this.$t("addr.addr33"), trigger: "blur" }],
        addressInfo: [{ required: true, message: this.$t("addr.addr34"), trigger: "blur" }],
        postcode: [{ required: true, message: this.$t("addr.addr35"), trigger: "blur" }],
        addressNo: [{ required: true, message: this.$t("addr.addr36"), trigger: "blur" }],
        address: [{ type: "array", required: true, message: this.$t("addr.addr37"), trigger: "blur" }],
      },
      defaultParams: {
        label: "text",
        value: "id",
        children: "children",
        expandTrigger: "click",
        checkStrictly: false,
      },
    };
  },
  watch: {
    formData: {
      handler(val, old) {
        if (val) {
          console.log(val, "=======val");
          this.sub.addressValue = [val.country];
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getAddressList_rp();
    this.loadEditData();
  },
  methods: {
    loadEditData() {
      if (this.isEdit) {
        this.formData.countryCode = this.props.countryCode;
        this.addressStr = `${this.$t("oneEight45")}${this.props.countryName}${this.$t("oneEight46")}`;
        clonKeys(this.formData, this.props);
        this.formData.address = [Number(this.props.provence), Number(this.props.city), Number(this.props.area)];
      }
    },
    onCancel() {
      this.$emit("on-cancel");
    },
    getTreeData(data) {
      // 循环遍历json数据
      for (var i = 0; i < data.length; i++) {
        if (data[i].levelType !== "4") {
          if (data[i].children.length < 1) {
            // children若为空数组，则将children设为undefined
            data[i].children = undefined;
          } else {
            // children若不为空数组，则继续 递归调用 本方法
            this.getTreeData(data[i].children);
          }
        } else {
          continue;
        }
      }
      return data;
    },
    async getAddressList_rp() {
      //获取地址列表
      let url = "cms/configAccountNumber/getAddressList";
      const { data: res } = await this.$http.get(url);
      this.options = this.getTreeData(res.data);
      console.log(res);
      console.log(this.options, 123);
    },
    addressChange(arr) {
      console.log(arr);
      // console.log(CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]);
    },
    verifyData() {
      return this.$refs.form.validate();
    },
    resetForm() {
      // 重置表单数据
      this.formData = {
        receiverName: undefined,
        receiverPhone: undefined,
        provinceName: undefined,
        provence: undefined,
        cityName: undefined,
        city: undefined,
        areaName: undefined,
        area: undefined,
        addressInfo: undefined,
        postcode: undefined,
        addressNo: undefined,
        notes: undefined,
        address: [],
      };

      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    onSave(item = {}) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            ...this.formData,
            ...item,
            type: 0,
            provence: this.formData.address[0],
            city: this.formData.address[1],
            area: this.formData.address[2],
            defaultAddress: "0",
          };

          // 如果是编辑模式，需要传递ID
          if (this.isEdit && this.props.id) {
            data.id = this.props.id;
          }

          this.$http
            .post("cms/configAddressInfo/insertAndEdit", data)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: res.data.message,
                });

                // 根据编辑/新增状态执行不同操作
                if (!this.isEdit) {
                  this.resetForm();
                }
                this.$emit("on-change", res.data);
                this.$emit("initAddress");
                this.$emit("update:show", false);
              } else {
                this.$message({
                  type: "warning",
                  message: res.data.message,
                });
              }
            })
            .catch((error) => {
              console.error("保存地址失败:", error);
              this.$message({
                type: "error",
                message: "保存失败，请重试",
              });
            });
        } else {
          console.log("表单校验失败");
          return false;
        }
      });
    },
    onFocus() {},
  },
};
</script>

<style scoped lang="less">
.el-card {
  width: 600px;
}

.el-button {
  height: 38px;
  width: auto;
  min-width: 100px;
}
.custom-input-select {
  width: 90px;
  height: 100%;
  border-right: 1px solid #ffefd0;
  flex: none;
}
.custom-input-select :deep(.el-select__wrapper) {
  height: 100%;
  box-shadow: none;
}
.custom-input-select :deep(.el-input__wrapper:hover) {
  border: none !important;
  box-shadow: none !important;
}
.form_ :deep(.el-input__inner::placeholder),
.form_ :deep(.input::placeholder) {
  font-size: 10px;
}
.formitem {
  width: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 15px;
  box-sizing: border-box;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-right: 15px;
}
</style>
